import { useState } from 'react';
import { Spinner } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell, faBellOn } from '@fortawesome/pro-regular-svg-icons';
import { getRequest } from '../../Helper/ApiClient';
import style from './NotifyUser.module.scss?module';
import clsx from 'clsx';

type NotifyUserPropsT = {
  has_notify_me: boolean;
  id: number;
  className?: string;
  /** Bell plus a short label, only the bell below md; the full text stays the
      accessible name. For narrow quantity columns (dashboard quick order). */
  compact?: boolean;
};

const NotifyUser = ({
  has_notify_me,
  id,
  className,
  compact = false,
}: NotifyUserPropsT) => {
  const [hasNotifyMe, setHasNotifyMe] = useState<boolean>(has_notify_me);
  const { refetch, isFetching } = getRequest(
    `/api/flavour/${id}/updateNotify/${!hasNotifyMe ? 1 : 0}`,
    undefined,
    { enabled: false }
  );

  async function handleToggleNotifier() {
    const result = await refetch();
    if (result.isSuccess) {
      setHasNotifyMe((prev) => !prev);
    }
  }

  const label = hasNotifyMe ? "You'll be notified" : 'Notify me when available';

  return (
    <div
      className={clsx(
        'w-100 h-100 form-control text-center border-0 fw-bold lh-sm d-flex align-items-center justify-content-center',
        style.notifyUser,
        className
      )}
    >
      {isFetching ? (
        <Spinner animation="border" size="sm" />
      ) : compact ? (
        // Marketing 20.10.2026: "Notify me" next to the ETA, only the bell on
        // phones; the ETA is shown by the row's Availability column.
        <a
          href={void 0}
          role="button"
          className="lh-1"
          aria-label={label}
          onClick={handleToggleNotifier}
        >
          <FontAwesomeIcon icon={hasNotifyMe ? faBellOn : faBell} />
          <small className="d-none d-md-inline ms-1">
            {hasNotifyMe ? 'Notified' : 'Notify me'}
          </small>
        </a>
      ) : (
        <a
          href={void 0}
          role="button"
          className="lh-1"
          onClick={handleToggleNotifier}
        >
          <small>{label}</small>
        </a>
      )}
    </div>
  );
};

export default NotifyUser;
